import { Box, Container, Typography, Stack, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import bgVideo from "../assets/bg.mp4";
import logoBenext from "../assets/logo-benext.png";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <Box
      id="hero"
      sx={{
        position: "relative",
        minHeight: { xs: 560, md: 720 },
        display: "grid",
        placeItems: "center",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      {/* background video */}
      <Box
        component="video"
        src={bgVideo}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center center",
          zIndex: 0,
        }}
      />

      {/* overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          background:
            "linear-gradient(180deg, rgba(45,46,47,0.45) 0%, rgba(45,46,47,0.55) 40%, rgba(45,46,47,0.65) 100%)",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 2, px: { xs: 2, sm: 2, md: 3 } }}>
        <Box sx={{ height: { xs: 120, md: 0 } }} />

        {/* Logo */}
        <Box
          component="img"
          src={logoBenext}
          alt="be>next"
          sx={{
            height: { xs: 64, md: 100 },
            maxWidth: { xs: 330, sm: 330, md: "none" },
            width: "auto",
            mb: { xs: 3, md: 4 },
            mx: "auto",
            display: "block",
          }}
        />

        {/* Título */}
        <Typography
          component="h1"
          sx={{
            color: "#fff",
            lineHeight: 1.15,
            mb: 3,
            fontWeight: 400,
            maxWidth: { xs: 358, sm: 720, md: 1000 },
            mx: "auto",
            fontSize: { xs: 28, sm: 36, lg: 44 },
          }}
        >
          <Trans
            i18nKey="hero.title"
            components={{ bold: <Box key="bold" component="span" sx={{ fontWeight: 800 }} /> }}
          />
        </Typography>

        {/* Parágrafo */}
        <Typography
          sx={{
            maxWidth: { xs: 358, sm: 720, md: 1000 },
            mx: "auto",
            color: "rgba(255,255,255,0.85)",
            mb: { xs: 3, md: 4 },
            fontSize: { xs: 16, md: 16, lg: 18 },
            lineHeight: 1.6,
          }}
        >
          {t("hero.since")}
        </Typography>

        {/* CTAs */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          sx={{
            maxWidth: { xs: 358, sm: 720 },
            mx: "auto",
          }}
        >
          <Button
            href="#contato"
            variant="contained"
            size="large"
            sx={{
              height: { xs: 44, sm: 44 },
              width: { xs: "100%", sm: "auto" },
              ":hover": { bgcolor: "#CEFF1A" },
            }}
          >
            {t("buttons.contact")}
          </Button>
          <Button
            href="#cases"
            variant="outlined"
            size="large"
            sx={{
              height: { xs: 44, sm: 44 },
              width: { xs: "100%", sm: "auto" },
              ":hover": { color: "#CEFF1A" },
            }}
          >
            {t("buttons.caseStudies")}
          </Button>
        </Stack>

        <Box sx={{ height: { xs: 24, sm: 32, md: 0 } }} />
      </Container>
    </Box>
  );
}